import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrTimesheetCreateAddPage } from './klmr-timesheet-create-add';

@NgModule({
  declarations: [
    KlmrTimesheetCreateAddPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrTimesheetCreateAddPage),
  ],
})
export class KlmrTimesheetCreateAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-timesheet-create-add/klmr-timesheet-create-add.module.ts